export default {
  date: {
    SHORT: "YYYY-MM-DD HH:mm:ss"
  }
}